module.exports = __webpack_public_path__ + "img/home-praise-avator-02.bb781891.png";